import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { LoadingSpinner } from "components/LoadingSpinner";
import React from "react";
import { useGetList } from "react-admin";

export const CompanyFilterField = ({ value, onChange, label }) => {
	const { ids, data, loading } = useGetList(
		"customer-companies",
		{ page: 1, perPage: 1000 },
		{ field: "id", order: "ASC" }
	);

	if (loading) {
		return <LoadingSpinner />;
	}

	const customers = ids.map((id) => data[id]);

	const selectedCustomer = value != null ? customers.find((item) => item.id === value) : null;

	return (
		<Autocomplete
			options={customers}
			getOptionLabel={(option) => option?.full_name || ""}
			getOptionSelected={(option, val) => option.id === val.id}
			loading={loading}
			value={selectedCustomer}
			onChange={(e, newValue) => onChange?.(newValue ? newValue.id : undefined)}
			renderInput={(params) => (
				<TextField {...params} label={label} variant="outlined" margin="none" size="small" />
			)}
			style={{ width: 200, marginLeft: 8 }}
			clearOnEscape
			autoHighlight
		/>
	);
};
